import { defineStore } from 'pinia'
import baseService from '@/utils/http/axios'

export const useConsultation = defineStore('consultation', {
  state: () => ({}),
  actions: {
    // 分页查询咨询列表
    async getConsultationPage(params: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/consultation/page',
          method: 'get',
          params
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 咨询详情
    async getConsultationInfo(id: string | number) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/consultation/info/${id}`,
          method: 'get'
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 新增咨询
    async createConsultation(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/consultation/create',
          method: 'post',
          data
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 确认处理
    async confirmConsultation(id: string | number) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/consultation/confirm/${id}`,
          method: 'post'
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
})
